export default __webpack_public_path__ + "static/media/art-0-pergola3.851d49d6.jpeg";